// All Reservations lifecycle sub-tabs. Keys are the API `status` values; labels are the UI text.
export const STATUS_TABS = {
  upcoming: { label: "Upcoming" },
  requested: { label: "Requests" },
  completed: { label: "Completed" },
  canceled: { label: "Canceled" }
}

// Canonical list of the reservation status values (single source of truth for PropTypes etc.).
export const RESERVATION_STATUSES = Object.keys(STATUS_TABS)

// Sub-tabs the backend serves as future-only (booked_date >= today): past dates are blocked
// and a carried-over past date snaps forward. Change here to adjust every date restriction.
export const FUTURE_ONLY_STATUSES = ["upcoming", "requested"]

// Sort the listings fall back to when no column is actively sorted — including after the user
// cancels a sort (Ant Design's third header click). The request always carries a sort, but with
// no column key set no header renders as sorted.
export const DEFAULT_SORT_KEY = "booked_date"
export const DEFAULT_SORT_ORDER = "asc"

export const REQUEST_TYPES = {
  upcoming: "booked",
  requested: "requested",
  completed: "completed",
  canceled: "canceled"
}

export const PAYMENT_STATUS = {
  partial: "partial",
  paid: "paid",
  partial_refund: "partial_refund"
}

export const getTimePeriods = (t) => ({
  day: t("bookings.day"),
  week: t("bookings.week"),
  month: t("bookings.month")
})

export const getStatusMessages = (t) => ({
  booked: {
    title: t("bookings.upcoming_title"),
    description: t("bookings.upcoming_description")
  },
  requested: {
    title: t("bookings.requests_title"),
    description: t("bookings.requests_description")
  },
  completed: {
    title: t("bookings.completed_title"),
    description: t("bookings.completed_description")
  },
  canceled: {
    title: t("bookings.canceled_title"),
    description: t("bookings.canceled_description")
  }
})

export const PAYMENT_OPTIONS = {
  deposit_later: "deposit_and_balance_later",
  deposit_cash: "deposit_and_balance_in_cash",
  full_now: "full_amount_today",
  full_cash: "full_amount_in_cash_on_day",
  full_link: "full_amount_by_link",
  deposit_link: "deposit_by_link_and_balance_later",
  deposit_link_in_cash: "deposit_by_link_and_balance_in_cash",
  pay_later: "pay_later"
}

export const initialValues = {
  isExistingClient: false,
  existing_client: null,
  firstName: "",
  lastName: "",
  email: "",
  phone_number: null,
  experience: null,
  date: null,
  duration: null,
  time: null,
  accessibility_required: false,
  accessibility_notes: "",
  notes: "",
  depositOnly: false,
  depositPercent: null,
  customDepositAmount: null,
  paymentOption: "",
  paymentType: undefined,
  collectPayment: "yes",
  recordPayment: 0,
  refundBy: ""
}

export const REFUND_CANCEL_REASONS = ["Equipment Issues", "Weather", "Pro or Employee Unavailable"]

// Payment collection labels rendered with a custom style (white surface, #8F4700 text)
export const OPERATOR_TO_COLLECT_LABELS = ["Operator To Collect", "Operator to Collect"]

export const BOOKING_SOURCE = {
  marketplace: "marketplace",
  manual: "manual",
  embedded: "embedded",
  website: "website"
}

export const BOOKING_MODES = {
  embedded: "embedded",
  clientBooking: "clientBooking",
  guideProfile: "guideProfile"
}

